import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import LandingPage from './Pages/LandingPage/LandingPage';
import ConditionsPage from './Pages/LandingPage/ConditionsPage';
import PolitiquesPage from './Pages/LandingPage/PolitiquesPage';
import RedirectToPharmaApp from './Helpers/RedirectToPharmaApp/RedirectToPharmaApp';
import './App.css';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className="App" >
          <Switch>
            <Route path="/" exact component={LandingPage} />
            <Route path="/conditions" component={ConditionsPage} />
            <Route path="/politiques" component={PolitiquesPage} />
            <Route component={RedirectToPharmaApp} />
          </Switch>
        </div>
      </BrowserRouter >
    );
  }
}

export default App;
